import React from 'react'
import classnames from 'classnames'
import { DonateButtonProps } from './types'
import { findApiV4Link } from 'shared'

export const DonateButton = ({ fundraisingEvent, className }: DonateButtonProps): JSX.Element | null => {
  if (fundraisingEvent.donations_prohibited) return null
  const donateUrl = findApiV4Link({ ofObject: fundraisingEvent, withRel: 'new_donation' })
  return (
    <a className={classnames('btn btn-primary', className)} href={donateUrl}>
      {i18n.t('misc.donate_button')}
    </a>
  )
}
